module.exports = __webpack_public_path__ + "img/1.a8c55c37.png";